import { render, staticRenderFns } from "./orderinstallAplayAdd.vue?vue&type=template&id=52f8ac66&"
import script from "./orderinstallAplayAdd.vue?vue&type=script&lang=ts&"
export * from "./orderinstallAplayAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports